// src/components/PrivacyPolicy.js
import React from 'react';
import PolicyPage from './PolicyPage';

function PrivacyPolicy() {
  return (
    <PolicyPage title="Privacy Policy" lastUpdated="[Date]">
      <p>IronBhai is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data.</p>
      <h2>1. Information We Collect</h2>
      <ul>
        <li>Personal details: Name, phone number, email, address.</li>
        <li>Order details: Service type, pickup/delivery location, payment information.</li>
        <li>Device & usage data: IP address, device type, app usage patterns, cookies.</li>
      </ul>
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Process and deliver your orders.</li>
        <li>Communicate updates, offers, and support.</li>
        <li>Improve our services and app functionality.</li>
        <li>Comply with legal and regulatory requirements.</li>
      </ul>
      <h2>3. Data Sharing</h2>
      <ul>
        <li>We do not sell your personal data.</li>
        <li>We may share information with service partners for pickup, delivery, and payment processing.</li>
        <li>We may share with legal authorities if required by law or to protect our rights.</li>
      </ul>
      <h2>4. Data Security</h2>
      <ul>
        <li>We use encryption, secure servers, and access controls to protect your data.</li>
        <li>While we take reasonable steps to safeguard information, no system is 100% secure.</li>
      </ul>
      <h2>5. Cookies & Tracking</h2>
      <ul>
        <li>We may use cookies and analytics tools to enhance your experience.</li>
        <li>You can disable cookies through your browser/app settings.</li>
      </ul>
      <h2>6. Your Rights</h2>
      <ul>
        <li>Access, update, or delete your personal data.</li>
        <li>Opt out of marketing communications anytime.</li>
        <li>Request details of the data we hold about you.</li>
      </ul>
      <h2>7. Data Retention</h2>
      <ul>
        <li>We retain your data only as long as necessary for providing services and complying with legal obligations.</li>
      </ul>
      <h2>8. Third-Party Links</h2>
      <ul>
        <li>Our app/website may contain links to other sites. We are not responsible for their privacy practices.</li>
      </ul>
      <h2>9. Policy Updates</h2>
      <ul>
        <li>We may update this policy from time to time. The updated version will be posted on our app/website with a revised date.</li>
      </ul>
      <h2>10. Contact Us</h2>
      <ul>
        <li>📧 Email: <a href="mailto:support@ironbhai.com">support@ironbhai.com</a></li>
        <li>📞 Phone: +91 8688206969</li>
      </ul>
    </PolicyPage>
  );
}

export default PrivacyPolicy;
